"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.index = exports.swaps = exports.predictionMarkets = exports.orderbook = void 0;
var orderbook_1 = require("./orderbook");
Object.defineProperty(exports, "orderbook", { enumerable: true, get: function () { return __importDefault(orderbook_1).default; } });
var predictionMarkets_1 = require("./predictionMarkets");
Object.defineProperty(exports, "predictionMarkets", { enumerable: true, get: function () { return __importDefault(predictionMarkets_1).default; } });
var swaps_1 = require("./swaps");
Object.defineProperty(exports, "swaps", { enumerable: true, get: function () { return __importDefault(swaps_1).default; } });
exports.index = {
    rpc: {},
    typesAlias: {
        tokens: {
            AccountData: {
                free: "Balance",
                reserved: "Balance",
                frozen: "Balance",
            },
        },
    },
    types: {
        Address: "MultiAddress",
        Amount: "i128",
        AmountOf: "i128",
        Asset: {
            _enum: {
                CategoricalOutcome: "(MarketId, CategoryIndex)",
                ScalarOutcome: "(MarketId, ScalarPosition)",
                CombinatorialOutcome: null,
                PoolShare: "u128",
                Ztg: null,
            },
        },
        AuthorId: "AccountId",
        SerdeWrapper: "Balance",
        BlockNumber: "u64",
        CategoryIndex: "u16",
        Currency: "Asset",
        CurrencyIdOf: "Asset",
        CurrencyId: "Asset",
        Index: "u64",
        Lookup: "MultiAddress",
        MarketIdOf: "u128",
        MaxRuntimeUsize: "u64",
        Moment: "u64",
        MultiHash: {
            _enum: {
                Sha3_384: "[u8; 50]",
            },
        },
        RoundIndex: "u32",
        ScalarPosition: {
            _enum: ["Long", "Short"],
        },
    },
};
//# sourceMappingURL=index.js.map